import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SareLogo from "../../../Assets/img/SareLogo.png";
import axios from "axios";
import ApiName from "../../../ApiName";
import { motion, AnimatePresence } from "framer-motion";

const Navbar = () => {
  const [linkShow, setLinkShow] = useState(false);
  const [mobileShopExpanded, setMobileShopExpanded] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios.get(ApiName + "/Category")
      .then(res => setCategories(res.data))
      .catch(err => console.error("Failed to load categories", err));
  }, []);

  const handleLinkShow = () => {
    setLinkShow(!linkShow);
  };

  return (
    <div className="w-full border-b border-gray-200 bg-white sticky top-0 z-50">
      <header className="flex items-center justify-between max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="w-3/12">
          <Link to={"/"}>
            <img src={SareLogo} className="mx-2 w-14" alt="" />
          </Link>
        </div>

        <div className="flex items-end justify-end w-9/12 text-xs antialiased md:text-sm rubik h-14">
          <div
            onClick={handleLinkShow}
            className="px-2 space-y-2 cursor-pointer lg:hidden "
          >
            <span className="block w-8 h-0.5 bg-black"></span>
            <span className="block w-8 h-0.5 bg-black"></span>
            <span className="block w-8 h-0.5 bg-black"></span>
          </div>
          <ul className="hidden list-none lg:block">
            <li className="inline-block px-5">
              <Link to="home" className="">
                HOME
              </Link>
            </li>
            <li className="relative inline-block px-1 md:px-5 group">
              <Link to="shop" className="py-5">
                SHOP
              </Link>
              {categories.length > 0 && (
                <div className="absolute left-0 z-50 hidden pt-4 top-full group-hover:block">
                  <div className="w-48 bg-white border border-gray-200 shadow-xl rounded-md">
                    <ul className="flex flex-col">
                      {categories.map((c) => (
                        <li key={c.id} className="relative group/subcat">
                          <Link
                            to={`shop?category=${c.id}`}
                            className="block px-4 py-3 text-gray-700 hover:bg-gray-100 hover:text-black transition-colors flex justify-between items-center"
                          >
                            {c.name}
                            {c.subCategories && c.subCategories.length > 0 && (
                                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path></svg>
                            )}
                          </Link>
                          {c.subCategories && c.subCategories.length > 0 && (
                            <div className="absolute right-full lg:right-auto lg:left-full top-0 hidden group-hover/subcat:block pr-1 lg:pr-0 lg:pl-1">
                              <div className="w-48 bg-white border border-gray-200 shadow-xl rounded-md overflow-hidden">
                                <ul>
                                  {c.subCategories.map((s) => (
                                    <li key={s.id}>
                                      <Link
                                        to={`shop?category=${c.id}&subCategory=${s.id}`}
                                        className="block px-4 py-3 text-gray-600 hover:bg-gray-100 hover:text-black transition-colors"
                                      >
                                        {s.name}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </li>

            <li className="inline-block px-1 md:px-5">
              <Link to="about" className="">
                ABOUT
              </Link>
            </li>
            <li className="inline-block px-1 md:px-5">
              <a href="https://www.instagram.com/sareabbasi7" className="">
                INSTA
              </a>
            </li>
          </ul>
        </div>
      </header>
      
      <AnimatePresence>
        {linkShow && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden mt-5 border-t-2 border-t-black"
          >
            <ul className="list-none pt-3">
              <li className="px-5 py-5 text-center">
                <Link to="home" onClick={handleLinkShow}>
                  HOME
                </Link>
              </li>
              <li className="px-1 py-5 text-center md:px-5">
                <div className="flex justify-center items-center gap-2">
                  <Link to="shop" onClick={handleLinkShow}>
                    SHOP
                  </Link>
                  {categories.length > 0 && (
                    <button 
                      onClick={() => setMobileShopExpanded(!mobileShopExpanded)}
                      className="p-1 text-gray-500 focus:outline-none"
                    >
                      <motion.svg 
                        animate={{ rotate: mobileShopExpanded ? 180 : 0 }}
                        transition={{ duration: 0.3 }}
                        className="w-4 h-4" 
                        fill="none" stroke="currentColor" viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                      </motion.svg>
                    </button>
                  )}
                </div>
                
                <AnimatePresence>
                  {mobileShopExpanded && categories.length > 0 && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden mt-4"
                    >
                      <ul className="mb-2 space-y-4 bg-gray-50 py-4 rounded-md mx-4 border border-gray-100 shadow-inner">
                        {categories.map((c) => (
                          <li key={c.id}>
                            <Link to={`shop?category=${c.id}`} onClick={handleLinkShow} className="block font-medium text-gray-800">{c.name}</Link>
                            {c.subCategories && c.subCategories.length > 0 && (
                              <ul className="mt-2 space-y-2">
                                {c.subCategories.map((s) => (
                                  <li key={s.id}>
                                    <Link to={`shop?category=${c.id}&subCategory=${s.id}`} onClick={handleLinkShow} className="block text-sm text-gray-500 hover:text-black">- {s.name}</Link>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                      </ul>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>

              <li className="px-1 py-5 text-center md:px-5">
                <Link to="about" onClick={handleLinkShow}>
                  ABOUT
                </Link>
              </li>
              <li className="px-1 py-5 text-center md:px-5">
                <a href="https://www.instagram.com/sareabbasi7" onClick={handleLinkShow}>
                  INSTA
                </a>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Navbar;
